/**
* focus on first error mesage
*/

let error = document.querySelector('.is-invalid');

if (error)
    setTimeout(() => {
        console.log(error);
        error.focus();
    }, 100);

if (!error) {
    let captcaErrorEl = document.querySelector('.il-captcha-error');
    if (captcaErrorEl)
        captcaErrorEl.scrollIntoView({ block: "center" });
}
